import { render } from "./CPdashboardView.vue?vue&type=template&id=2cb30a6b"
import script from "./CPdashboardView.vue?vue&type=script&lang=js"
export * from "./CPdashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__